import 'kk-web-components';

let requireAll = (req) => {
  return req.keys().map(req);
};
//console.log('webpack running');

/**
 * icons
 */
requireAll(require.context('./icons/', true, /\.svg$/));

import './scss/main.scss';

// Import all JavaScript that should always be loaded on all pages
import 'bootstrap';
import jQuery from 'jquery';
import './js/bricks/accordion';
import './js/bricks/bmi-calculator';
import './js/bricks/icons';
import './js/bricks/nutrients-slider';
import './js/bricks/foods-showcase';
import './js/bricks/lifeworlds-articles';
import './js/bricks/picture-video';
import './js/bricks/products-overview-filter';
import './js/bricks/salesforce-form/product-sample-request';
import './js/bricks/salesforce-form/sf-form-handler';
import './js/bricks/newsletter-signup';
import './js/data-layer';
import './js/search';
import './js/tracking';
import './js/cart-counter';
import './js/header';
import { capturePromoFromUrl } from './components-shop/promo/promoCapture';

window.$ = window.jQuery = jQuery;

// ORT-3077: capture a `?promo=` newsletter deep link on any page (not only PDPs), so the code
// is remembered site-wide and applies at add-to-cart / surfaces on later PDPs.
capturePromoFromUrl();
